// This is the JS to toggle between grid and list view for the collection page

import { setCookie } from '../cookie-utils';

document.addEventListener('DOMContentLoaded', () => {
  const viewToggleContainer = document.querySelector('.collection__view');
  const collectionWrapper = document.querySelector('.collection');
  // const gridRadio = document.querySelector('.collection__view input[value="grid"]');
  // const listRadio = document.querySelector('.collection__view input[value="list"]');

  if (!viewToggleContainer || !collectionWrapper) {
    return;
  }

  function setMobileViewMode(mode: string) {
    // Add list-view class to container if enabling list view
    collectionWrapper?.classList.toggle('product-cards--list-view', mode === 'list');

    // Only set cookie if consented
    if (Cookiebot?.consent.preferences) {
      setCookie('mobileViewMode', mode, 365);
    }
  }

  // Hook up event listeners
  const radios = document.querySelectorAll('.collection__view input[type="radio"]');
  radios.forEach((radio) => {
    radio.addEventListener('change', (e) => {
      const target = e.target as HTMLInputElement;
      setMobileViewMode(target.value);
    });
  });
});
